module.exports = __webpack_public_path__ + "static/media/Slide4.6da89532.png";